<template>
<code>
&lt;head><br>
&lt;script src="https://swarm.video/swarm.js">&lt;/script><br>
&lt;link rel="stylesheet" href="https://cdn.plyr.io/3.5.6/plyr.css"><br>
&lt;script src="https://cdn.plyr.io/3.5.6/plyr.js">&lt;/script><br>
&lt;script src="https://cdn.jsdelivr.net/npm/hls.js@latest">&lt;/script><br>
&lt;style><br>
#wrapper {<br>
&nbsp;&nbsp;&nbsp;&nbsp;width: 720px;<br>
&nbsp;&nbsp;&nbsp;&nbsp;margin-left: auto;<br>
&nbsp;&nbsp;&nbsp;&nbsp;margin-right: auto;<br>
&nbsp;&nbsp;&nbsp;&nbsp;display: block;<br>
}<br>
&lt;/style><br>
&lt;/head><br>
&lt;body><br>
&lt;div id="wrapper"><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;video id="video">&lt;/video><br>
&lt;/div><br>
&lt;script><br>
let engine = new p2pml.hlsjs.Engine({segments: {swarmId: "CustomSwarmId"},loader: {httpUseRanges:false, WaitForTracker: true, WaitForTrackerCounter:4500}}); <br>
var video = document.getElementById("video");<br>
var player = new Plyr(video, {captions: {active: true, update: true}});<br>
var hls = new Hls({<br>
&nbsp;&nbsp;&nbsp;&nbsp;liveSyncDurationCount: 7, // To have at least 7 segments in queue<br>
&nbsp;&nbsp;&nbsp;&nbsp;loader: engine.createLoaderClass()<br>
});<br>
p2pml.hlsjs.initHlsJsPlayer(hls);<br>
hls.loadSource("https://wowza.peer5.com/live/smil:bbb_abr.smil/playlist.m3u8");<br>
hls.attachMedia(video);<br>
&lt;/script><br>
&lt;/body><br>

                            </code>
</template>

<script>
export default {
  name: "plyr",
 
  
};
</script>
